import React, { useMemo } from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { MenuItem } from 'primereact/menuitem';
import { useTranslation } from 'react-i18next';
import { useKnowledgeBase } from './knowledgeBaseContext';

export const Breadcrumbs = () => {
	const { baseBreadcrumbModel, goToHome } = useKnowledgeBase();
	const { t } = useTranslation();

	const customHome: MenuItem = {
		template: () => (
			// eslint-disable-next-line react/button-has-type,jsx-a11y/anchor-is-valid
			<a className=" p-menuitem-link" href="#" onClick={goToHome}>
				<i className="pi pi-book primary md:hidden" />
				<span className="hidden md:inline">{t('knowledgeBase.title')}</span>
			</a>
		),
	};

	const breadcrumbModel: MenuItem[] = useMemo(() => {
		return [...baseBreadcrumbModel];
	}, [baseBreadcrumbModel]);

	return <BreadCrumb model={breadcrumbModel} home={customHome} className="mb-3" />;
};
